import type {
  CreateEnvelopeRequest,
  EnvelopeResponse,
  SignRequest,
} from '../types/envelope';
import { API_BASE_URL } from '../lib/constants';
import { api } from './api';

export async function createEnvelope(
  body: CreateEnvelopeRequest,
): Promise<EnvelopeResponse> {
  const { data } = await api.post<EnvelopeResponse>('/envelopes', body);
  return data;
}

export async function sendEnvelope(id: string): Promise<void> {
  await api.post(`/envelopes/${id}/send`);
}

export async function viewEnvelope(id: string, token: string): Promise<string> {
  const base = API_BASE_URL.replace(/\/$/, '');
  const params = new URLSearchParams({ token });
  const res = await fetch(`${base}/envelopes/${id}/view?${params.toString()}`);
  const json = (await res.json()) as { data?: string; error?: { message?: string } };
  if (!res.ok || json.error) {
    throw new Error(json.error?.message ?? 'Failed to load envelope');
  }
  return json.data ?? '';
}

export async function signEnvelope(
  id: string,
  body: SignRequest,
): Promise<EnvelopeResponse> {
  const base = API_BASE_URL.replace(/\/$/, '');
  const res = await fetch(`${base}/envelopes/${id}/sign`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
  const json = (await res.json()) as {
    data?: EnvelopeResponse;
    error?: { message?: string };
  };
  if (!res.ok || json.error) {
    throw new Error(json.error?.message ?? 'Failed to sign');
  }
  if (!json.data) throw new Error('Empty response');
  return json.data;
}

export async function signEnvelopeAuthed(
  id: string,
  body: SignRequest,
): Promise<EnvelopeResponse> {
  const { data } = await api.post<EnvelopeResponse>(`/envelopes/${id}/sign`, body);
  return data;
}

export async function getEnvelopesByTaxCase(
  taxCaseId: string,
): Promise<EnvelopeResponse[]> {
  const { data } = await api.get<EnvelopeResponse[]>(
    `/envelopes/tax-case/${taxCaseId}`,
  );
  return data;
}
